import AppErrorBoundary from 'components/AppErrorBoundary/AppErrorBoundary'
import Router from './Router'

function App() {
    return (
        <div id="app">
            <AppErrorBoundary>
                <Router />
            </AppErrorBoundary>
        </div>
    )
}

export default App
